<template>
  <!-- 语音文件 -->
  <div class="di main-wrap">
    <div>
      <embed
        :ref="index"
        :src="wavUrl"
        class="embed"
        menu="true"
        loop="false"
        align="center"
        preload="auto"
        autostart="false"
        @onplay="onPlay"
        @onerror="onError"
        @onpause="onPause"
        @onwaiting="onWaiting"
        @ontimeupdate="onTimeupdate"
        @onloadedmetadata="onLoadedmetadata"
      />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    theUrl: {
      type: String,
      required: true
    },
    index: {
      type: String,
      required: true
    },
    PlayOrPause: {
      type: String,
      default: ''
    }
  },
  name: 'VueAudio',
  data () {
    return {
      L: 0,
      // wavUrl: 'http://47.102.202.171:19008/official/materials/downloadWav/1240986388164534273.wav',
      wavUrl: this.theUrl,
      url: this.theUrl,
      isIE: false,
      audio: {
        currentTime: 0,
        maxTime: String(this.time),
        playing: false, // 是否自动播放
        muted: false, // 是否静音
        speed: 1,
        waiting: true,
        preload: 'auto'
      }
    }
  },
  methods: {
    // 开始播放
    // startPlay (index) {
    //   console.log('播放', index)
    //   document.getElementById(index).play()
    // },
    // // 暂停
    // pausePlay (index) {
    //   document.getElementById(index).pause()
    //   // this.$refs[index].pause()
    // },
    // // 当音频暂停
    // onPause () {
    //   console.log('暂停', index)
    //   const id = 'pause|' + this.index
    //   this.audio.playing = false
    // },
    // // 当发生错误, 就出现loading状态
    // onError () {
    //   this.audio.waiting = true
    // },
    // // 当音频开始等待
    // onWaiting (res) {
    //   console.log('wait')
    //   console.log(res)
    // },
    // onTimeupdate (res) {
    //   this.audio.currentTime = res.target.currentTime
    //   this.sliderTime = parseInt(this.audio.currentTime / this.audio.maxTime * 100)
    // },
    // 当加载语音流元数据完成后，会触发该事件的回调函数
    // 语音元数据主要是语音的长度之类的数据
    // onLoadedmetadata (res) {
    //   console.log('loadedmetadata')
    //   // console.log(res)
    //   this.audio.waiting = false
    //   // this.audio.maxTime = parseInt(res.target.duration)
    //   // this.audio.maxTime = parseInt(this.$refs.audio.duration)
    //   // console.log('总时间', this.$refs.audio.duration)
    //   this.$emit('loading', 'false|' + this.index)
    //   // this.startPlay(this.index)
    //   // this.cache = true
    // },
    // // 当音频开始播放
    // onPlay (res) {
    //   console.log('play')
    //   // const id = 'true|' + this.index
    //   // this.$emit('open', id)
    //   // console.log(res)
    //   this.audio.playing = true
    //   this.audio.loading = false
    //   if (!this.controlList.onlyOnePlaying) {
    //     return
    //   }
    //   let target = res.target
    //   let audios = document.getElementsByTagName('audio');
    //   [...audios].forEach((item) => {
    //     if (item !== target) {
    //       item.pause()
    //     }
    //   })
    // }
  },
  watch: {
    // PlayOrPause (val, oldval) {
    //   // true  播放
    //   console.log('val,oldval')
    //   console.log(val)
    //   let result = val.split('|')
    //   console.log(result)
    //   if (result[0] === 'false') {
    //     this.pausePlay(result[1])
    //   }
    //   if (result[0] === 'true') {
    //     this.startPlay(result[1])
    //   }
    //   // flase
    // }
  },
  mounted () {
  },
  created () {
  }

}

</script>

<style scoped>
.di {
  display: inline-block;
}
.embed {
  margin: 0px auto;
  border: 3px solid gray;
  border-radius: 30px;
  padding: 10px;
  background-color: #f8f8f8;
  height: 65px;
  width: 300px;
  margin-top: 30px;
  border: 1px solid gray;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/solution/Rs/embd.vue